import "@hotwired/turbo-rails";
import "./controllers";
import { mountLoginApp } from "./sessions/LoginApp";

document.addEventListener("turbo:load", mountLoginApp);
